import { codeSplit, Controller, FetchOptions, Result } from 'bernie-core';
import { PageData } from 'bernie-http';
import '../client/temp-common-imports';

export class EntityTermsAndConditionsController implements Controller {
  public pageId = 'EntityTermsAndConditions';
  public path = '/:localeName/entity-terms-and-conditions';
  public routeName = 'entity-terms-and-conditions';
  public bundles = [];

  public component = codeSplit(
    () =>
      import(/* webpackChunkName: "entity-terms-and-conditions-page" */ '../views/entity-terms-and-conditions-page'),
  );
  public exact = true;

  // tslint:disable-next-line:prefer-function-over-method
  public fetch(options: FetchOptions) {
    return Promise.resolve(Result.ok());
  }

  // tslint:disable-next-line:prefer-function-over-method
  public fetchPageData(): Promise<PageData> {
    return Promise.resolve({ title: 'Terms & Conditions' }) as Promise<PageData>;
  }
}
